import React from 'react'
import { Col, Row } from 'react-bootstrap'

const NameField = props => {
  // props for this file
  const { personName, error, personNamete, disableInput } = props
  return (
    <div>
      <Row>
        <Col md={6} xs={12}>
          <div className='shotbio'>
            <label>
              Person name_En<div className='mandatory'>*</div>
            </label>
            <div className='inputbox'>
              {/* input for person name in english */}
              <input
                name='name'
                type='text'
                value={personName}
                className='form-control'
                onChange={props.handleNameChange}
                size=''
                disabled={disableInput === true}
              />
            </div>
            {error.personName && (
              <div className='mandatory1'>
                <span>{error.personName}</span>
              </div>
            )}
          </div>
        </Col>
        {/* displays only when person name in english is not empty */}
        {personName !== '' && (
          <Col md={6} xs={12}>
            {personName !== '' && (
              <div className='shotbio'>
                <label>
                  Person name_Te<div className='mandatory'>*</div>
                </label>
                <div className='inputbox'>
                  {/* input for person name in Telugu */}
                  <input
                    name='name'
                    type='text'
                    value={personNamete}
                    className='form-control'
                    onChange={props.handleNameteChange}
                    size=''
                    disabled={disableInput === true}
                  />
                </div>
                {error.personNamete && (
                  <div className='mandatory1'>
                    <span>{error.personNamete}</span>
                  </div>
                )}
              </div>
            )}
          </Col>
        )}
      </Row>
      {/* error display if personName is not filled in input */}
    </div>
  )
}

export default NameField
